import { type UUID } from '~/types/common';

import { SiteListItem, useQuerySitesInfinite } from '~/data/site';

import { MultiItemsManager } from './MultiItemsManager';

type P = {
  readonly filterActive?: boolean | null;
  readonly isCreatingNewEntity: boolean;
  readonly isDisabled?: boolean;
  readonly label?: string;
  readonly onChange?: (selectedIds: UUID[]) => void;
  readonly onSaveSelection?: () => void;
  readonly onSelectedItemClick?: (id: UUID) => void;
  readonly parentOrganizationalUnitId?: UUID;
};

const selectSites = (data: SiteListItem[]) =>
  data?.map(({ companyName, id, name }) => ({
    id,
    name,
    secondaryInfo: companyName,
  }));

export const MultiItemsManagerSites = ({
  filterActive = true,
  isCreatingNewEntity,
  isDisabled = false,
  label = 'Standorte',
  onChange,
  onSaveSelection,
  onSelectedItemClick,
  parentOrganizationalUnitId,
}: P) => {
  const useGetterFunctionSelectedItems = (searchString: string) => {
    const query = useQuerySitesInfinite({
      filterActive: filterActive ?? undefined,
      filterParentOu: parentOrganizationalUnitId ?? undefined,
      searchString,
    });

    if (!isCreatingNewEntity) {
      return query;
    }

    // Return an empty result to ensure that no items are selected initially when using this component in a form for creating a new entity.
    return {
      data: [],
      fetchNextPage() {},
      hasNextPage: false,
      isFetchingNextPage: false,
      isLoading: false,
      totalCount: 0,
    };
  };

  const useGetterFunctionSelectableItems = (searchString: string) =>
    useQuerySitesInfinite({
      filterActive: filterActive ?? undefined,
      filterNotParentOu: parentOrganizationalUnitId ?? undefined,
      searchString,
    });

  return (
    <MultiItemsManager
      fieldName="name"
      getterFunctionSelectableItems={useGetterFunctionSelectableItems}
      getterFunctionSelectedItems={useGetterFunctionSelectedItems}
      isDisabled={isDisabled}
      label={label}
      onChange={onChange}
      onSaveSelection={onSaveSelection}
      onSelectedItemClick={onSelectedItemClick}
      selectFunctionSelectableItems={selectSites}
      selectFunctionSelectedItems={selectSites}
    />
  );
};
